<template>
  <div class="layout-manager" :class="classes">
    <component :is="layout"></component>
  </div>
</template>

<script>
import LayoutDefault from "./LayoutDefault";
import LayoutEmpty from "./LayoutEmpty";
import LayoutSidebar from "./LayoutSidebar";

export default {
  name: "LayoutManager",
  data: () => ({
    layoutName: ""
  }),
  components: {
    LayoutDefault,
    LayoutEmpty,
    LayoutSidebar
  },
  computed: {
    classes() {
      return {
        "layout-manager_home": this.$route.name === "home"
      };
    },
    layout() {
      if (!this.layoutName) return;
      return this.layoutName;
      // import(
      //   /* webpackChunkName: "layout-[request]" */ `@/layouts/${this.layoutName}.vue`
      // );
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        const newLayout = route.meta.layout;
        if (!newLayout && !this.$route.name) return;
        this.layoutName = newLayout || "LayoutDefault";
      }
    }
  }
};
</script>

<style lang="scss">
.layout-manager {
  padding-top: 0;
}
</style>
